class Options extends Inscription {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize() {

		/// On lance les fonctions génériques (récap, tunnel)
		super.initialize();
		//super.form();

		const utilities = new utilitiesInscription();
		const formulaire = new Formulaire(config.form);

		let configOptions = {
			idBtnOption: 'btnOption',
			idModalAnnulation: 'modalFraisAnnulation',
			idBareme: 'bareme',
			idModalDroitsVoyageurs: 'modalDroitsVoyageurs',
			idDroitsVoyageurs: 'droitsVoyageurs'
		}
		// ! On n'écrase pas les propriétés déjà définies dans config,
		// on n'ajoute simplement les propriétes de config qui sont null
		config = {
			...configOptions,
			...config
		};

		let self = this;
		let idForm = config.idForm;
		// Cas du button de validation
		// selon que l'on soit sur une inscription ou une pose d'option
		let idBtnValidation = config.isOption ? config.idBtnOption : config.idBtnValidation;
		let btn = document.getElementById(idBtnValidation);

		// On appelle la fonction d'update du montant total lors de la sélection d'une assurance
		config.url.MajSelectedAssurance != undefined && this.eventChangeAssurance(this.config.url.MajSelectedAssurance);

		// On appelle la fonction d'update du montant total lors de la coche d'une chambre single
		// uniquement si elle existe
		config.hasOptionsSingle && this.eventChangechambre(this.config.url.MajChambreSingle);

		// Cas hors pose d'option
		!config.isOption && this.eventsShowInfosSpecifiques([
			[config.idModalAnnulation, config.idBareme],
			[config.idModalDroitsVoyageurs, config.idDroitsVoyageurs]
		]);
		!config.isOption && config.fieldsFormRequired.includes('validationVolInterieurNepal') && this.eventsShowInfosNepal('modalNepal', 'nepal');
		!config.isOption && config.fieldsFormRequired.includes('validationIfremmont') && this.eventsShowInfosNepal('modalIfremmont', 'Ifremmont');

		// Mise à jour du bouton de validation
		formulaire.initialize(idForm);


		// @Ajax
		// Spécificités Relance
		// On vérifie les données des pax en ajax
		// !!!!! RelanceOptionDevis config.path et config.page (paiement.aspx et voyage.aspx)
		if (config.page === 'relance') {

			utilities._eventChangeCivilite();


			for (var j = 0; j < config.nbPax; j++) {
				let arrayOfinputPax = [];
				let clePax = document.getElementById(`fieldsetVoyageur-${j}`).dataset.clePax;
				arrayOfinputPax.push(`civilite${clePax}`, `nom${clePax}`, `nomUsage${clePax}`, `prenom${clePax}`, `naissance${clePax}`);

				utilities._maskInput(`#naissance${clePax}`)

					for (var i = 0; i < arrayOfinputPax.length; i++) {
						document.getElementById(arrayOfinputPax[i]).addEventListener('blur', function (el) {
						let id = el.target.id.split(clePax);
						let value = el.target.value;
						let field = id[0];
						let type = '';
						switch (field) {
						case 'civilite':
							type = 'c';
							break;
						case 'nom':
							type = 'n';
								break;
						case 'nomUsage':
							type = 'nU';
								break;
						case 'prenom':
							type = 'p';
							break;
						case 'naissance':
							type = 'd';
							break;
						default:
							console.error(`Sorry, we are out of ${field}.`);
						}
						self.onChangeTraveler(clePax, type, value)
					})
				}
			}

			// Prestations
			let textareaChambre = document.getElementById('repartitionchambre');
			let textareaDemandeSpecifique = document.getElementById('demandespecifique');

			if (textareaChambre !== null) {
				textareaChambre.addEventListener('blur', function () {
					self.onInsertRepartition(config.numeroDossierCrypte, config.url.onInsertRepartition)
				});
			}

			if (textareaDemandeSpecifique !== null) {
				textareaDemandeSpecifique.addEventListener('blur', function () {
					self.onInsertDemandeSpecifique(config.numeroDossierCrypte, config.url.onInsertDemandeSpecifique)
				});
			}
		}
	}

	/// @Event
	/// validation serveur coordonnée pax sur les pages de relance
	onChangeTraveler(cle, type, value) {
		let self = this;
		if(type!= "nU")
			document.getElementById(`${type}_${cle}`).style.display = 'none';

		let error = true;
		if (type === 'd') {
			error = self._validateDate(value, type, cle);
		} else {
			error = false;
		}
		if ((value != "" && value != "0")) {
			if (error == false) {
				$.ajax({
					url: config.url.onChangeTraveler,
					data: {
						cle: cle,
						type: type,
						value: value
					},
					type: "POST",
					cache: true,
					async: true, ///important!appel syncrone
					success: function (data) {
						if (data == "ok") {
							document.getElementById(`${type}_${cle}`).style.display = 'block';
						}
					},
					error: function (data) {

					}
				});
			}
		} else {
			document.getElementById(`${type}_${cle}`).style.display = 'block';
		}
	}

	_validateDate(checkBirthDate, type, cle) {

		let self = this;
		if (!self._checkDate(checkBirthDate, type, cle)) {
			return true;
		}
		return false;
	}

	_checkDate(DateNaissance, type, cle) {
		var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
		var Val_date = DateNaissance;
		var Aujourdhui = new Date(); /*Stocke la date du jour au format date javascript*/

		if (!Val_date.match(dateformat)) {

			document.getElementById(`${type}_${cle}`).innerHTML = '* Veuillez saisir une date <br /> au format JJ/MM/AAAA.';
			document.getElementById(`d_${cle}`).style.display = 'block';
			return false;
		} else {
			var Separateur = new RegExp("[^0-9]", "g");
			var DateJs = Val_date.replace(Separateur, "");
			DateJs = new Date(DateJs.substring(4, 8), DateJs.substring(2, 4) - 1, DateJs.substring(0, 2));
			if (DateJs > Aujourdhui) {
				document.getElementById(`d_${cle}`).innerHTML = 'La date de naissance ne peut pas <br/> être postérieure à la date du jour.';
				document.getElementById(`d_${cle}`).style.display = 'block';
				return false;
			}
		}

		return true;
	}

	/// @Event
	/// => Modales infos spec
	eventsShowInfosSpecifiques(array) {
		let self = this;
		for (let [cle, valeur] of array) {
			document.getElementById(cle).addEventListener('click', function (el) {
				self._launchModal(el, valeur);
			});
		}
	}
	/// @Event
	/// => Modale info vol Népal
	eventsShowInfosNepal(btn, template) {
		let self = this;
		document.getElementById(btn).addEventListener('click', function (el) {
			self._launchModal(el, template);
		});
	}
	/// Set Content & title de la modale
	_launchModal(element, template) {
		let title = element.target.dataset.title || element.target.parentElement.firstChild.textContent.trim();
		let content = document.getElementById(template).innerHTML;
		modalPopup.init(content, title);
	}

	/// @Event check assurance
	/// => update montant recap
	eventChangeAssurance(url) {
		let self = this;
		let radios = document.querySelectorAll('[name="assurance"]');

		for (var i = 0; i < radios.length; i++) {
			radios[i].addEventListener('change', function (el) {
				self._assuranceUpdate(url, el.target.value);
				for (let radio of radios) {
					radio.parentElement.querySelector('button').dataset.readmore = false;
				}
				el.target.parentElement.querySelector('button').dataset.readmore = true;

			})
		}
	}

	/// @Event check chambre single
	/// => update montant recap
	eventChangechambre(url) {
		let self = this;

		document.getElementById(config.idOptionSingle).addEventListener('change', function (el) {
			self._chambreUpdate(url, el.target.checked)
		})
	}

	/// @Ajax
	/// Function appelée dans eventChangeAssurance()
	_assuranceUpdate(url, codeAssurance) {
		let self = this;
		let data = {
			codeProduit: config.codeProduit,
			dateDepart: config.dateDepart,
			valeur: codeAssurance,
			cle: config.numeroDossierCrypte
		}
		if (config.page === 'relance') {
			data.numdossier = config.numeroDossierCrypte;
		}

		self._postRequest(url, data);
	}

	/// @Ajax
	/// Function appelée dans eventChangechambre()
	_chambreUpdate(url, isChecked) {
		let self = this;
		let data = {
			codeProduit: config.codeProduit,
			dateDepart: config.dateDepart,
			demandeSingle: JSON.stringify(isChecked), // on envoie une string et non un boolean
			cle: config.numeroDossierCrypte
		}

		self._postRequest(url, data);
	}
	/// @Ajax
	/// Function appelée sur les pages de relance
	/// lorsque l'utilisateur tape dans <textarea>
	onInsertRepartition(cle, url) {
		var value = document.getElementById('repartitionchambre').value;

		let data = {
			cle: cle,
			value: value
		};

		if (value != '') {
			$.ajax({
				url: url,
				data: data,
				type: "POST",
				cache: true,
				async: false ///important!appel syncrone
			});
		}
	}
	/// @Ajax
	/// Function appelée sur les pages de relance
	/// lorsque l'utilisateur tape dans <textarea>
	onInsertDemandeSpecifique(cle, url) {
		var value = document.getElementById('demandespecifique').value;

		let data = {
			cle: cle,
			value: value
		};

		if (value != '') {
			$.ajax({
				url: url,
				data: data,
				type: "POST",
				cache: true,
				async: false ///important!appel syncrone
			});
		}
	}
}